module.exports = __webpack_public_path__ + "static/media/Youtube.401a3b5d.svg";